<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-stock-other modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>สต๊อคสินค้าที่อื่น</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2">
                                <div class="picture">
                                    <img src="/products/demo.png" />
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-10">
                                <div class="product-data">
                                    <img :src="contentData.productData.brandLogo" class="brand" v-if="contentData.productData.brandLogo" />
                                    <h2>{{ contentData.productData.name }}</h2>
                                    <span v-if="contentData.productData.size">ขนาด {{ contentData.productData.size }}</span>
                                </div>

                                <div class="top-option-block mt-3">
                                    <button :class="{ 'active': typeActive === typeStore.BRANCH }" @click="setActiveOption(typeStore.BRANCH)">สต๊อคในเครือสาขา</button>
                                    <button :class="{ 'active': typeActive === typeStore.OTHER }" @click="setActiveOption(typeStore.OTHER)">สต๊อคจากจากร้านอื่น</button>
                                </div>
                            </div>
                        </div>

                        <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

                        <template v-if="!isShowNetworkError">
                            <perfect-scrollbar>
                                <table class="mt-4">
                                    <thead>
                                        <tr>
                                            <th v-if="typeActive === typeStore.BRANCH">ชื่อสาขา</th>
                                            <th v-if="typeActive === typeStore.OTHER">ชื่อร้านค้า</th>
                                            <th>เบอร์ติดต่อ</th>
                                            <th>ที่อยู่</th>
                                            <th class="text-center">สถานะสินค้า</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in storeList" :key="index">
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.tel }}</td>
                                            <td>{{ item.address }}</td>
                                            <td class="text-center" v-if="typeActive === typeStore.BRANCH">
                                                <span class="stock number" v-if="item.totalStock > 0">{{ item.totalStock }}</span>
                                                <span class="stock no-stock" v-if="item.totalStock === 0">ไม่มีของ</span>
                                            </td>
                                            <td class="text-center" v-if="typeActive === typeStore.OTHER">
                                                <span class="stock available" v-if="item.stockAvailable">มีสินค้า</span>
                                                <span class="stock no-stock" v-if="!item.stockAvailable">ไม่มีของ</span>
                                            </td>
                                            <td class="text-center text-nowrap">
                                                <button class="btn btn-sm btn-blue" @click="openModalStock(contentData.key, item)">นำเข้าสินค้า</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </perfect-scrollbar>

                            <div class="no-data" v-if="typeActive === typeStore.BRANCH && storeList.length === 0 && !isLoading">
                                <b-icon icon="exclamation-diamond"></b-icon>
                                <span>ร้านค้าของท่านยังไม่มีสาขาแยกในระบบ</span>
                            </div>
                            <div class="no-data" v-if="typeActive === typeStore.OTHER && storeList.length === 0 && !isLoading">
                                <b-icon icon="exclamation-diamond"></b-icon>
                                <span>ไม่มีร้านค้าอื่นในระบบ</span>
                            </div>
                        </template>
                        <template v-else>
                            <div class="no-data">
                                <b-icon icon="exclamation-diamond"></b-icon>
                                <span>ข้อมูลส่วนต้องใช้การเชื่อมต่ออินเทอร์เน็ต โปรดตรวจสอบการเชื่อมต่อของอุปกรณ์ที่ท่านใช้</span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <inventory-modal-stock
                :isDisplay="isShowModalStock"
                :contentData="selectedInventoryData"
                :fixSupplier="supplierName"
                @stockUpdate="reloadStockData()"
                @hide="closeModalStock()">
            </inventory-modal-stock>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import Helper from '@/resources/Helper';
import InventoryModalStock from '@/components/inventory/ModalStock';
import DBInventory from '@/database/Inventory';
import DBStock from '@/database/Stock';
import DBSupplier from '@/database/Supplier';

export default {
    components: {
        InventoryModalStock
    },
    data() {
        return {
            isActive: false,
            isShowNetworkError: false,
            isShowModalStock: false,
            selectedInventoryData: null,
            supplierName: '',
            isLoading: true,
            storeList: [],
            typeActive: -1,
            typeStore: {
                BRANCH: 1,
                OTHER: 2
            }
        };
    },
    props: {
        isDisplay: Boolean,
        contentData: Object
    },
    watch: {
        isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.typeActive = this.typeStore.BRANCH;
                this.loadStockData();
            }
        }
    },
    methods: {
        setActiveOption(type) {
            this.typeActive = type;
            this.loadStockData();
        },
        hide() {
            this.$emit('hide');
        },
        async openModalStock(key, store) {
            const loader = this.$AppUtility.renderLoadBackdrop();

            this.supplierName = await this.checkSupplier(store);
            this.selectedInventoryData = await this.loadInventoryDetail(key);
            this.isShowModalStock = true;

            loader.hide();
        },
        closeModalStock() {
            this.isShowModalStock = false;
        },
        async checkSupplier(store) {
            const supplierList = await this.loadSupplierList();
            let supplierData = supplierList.find(x => x.name === store.name);

            if (!supplierData) {
                supplierData = {
                    key: '',
                    name: store.name,
                    contactPerson: store.contact,
                    contactTel: store.tel
                };
                    
                await DBSupplier.save(supplierData);
            }

            return supplierData.name;
        },
        async loadSupplierList() {
            let supplierList = [];
            const result = await DBSupplier.get();

            if (result.content && result.content.length > 0) {
                // Place into the Object
                supplierList = result.content;
            }

            return supplierList;
        },
        async loadInventoryDetail(key) {
            // Load Inventory Data
            const inventory = await DBInventory.getDetail(key);
            const stock = await DBStock.getDetail(key);

            inventory['stockData'] = {
                dots: stock.dots,
                reserve: stock.reserve
            };

            return inventory;
        },
        async loadStockData() {
            this.storeList = [];
            this.isLoading = true;
            const param = {
                type: this.typeActive
            };

            const result = await Helper.postAPI(Helper.getApiUrl(), '/api/stock/other-store', param);
            
            this.isLoading = false;

            if (result) {
                this.storeList = result.data;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.modal-stock-other {
    max-width: 1000px;

    .no-data {
        padding: 100px 20px;
    }

    .picture {
        img {
            display: block;
            width: 100%;
            max-width: 200px;
            margin: 0 auto 20px;
        }
    }

    .product-data {
        .brand {
            width: auto;
            max-width: 100%;
            height: 25px;
            margin: 0 auto 10px;
        }

        h2 {
            font-size: 28px;
            font-weight: bold;
            font-style: italic;
            margin: 0;
        }

        span {
            font-size: 14px;
            opacity: 0.7;
        }
    }

    table {
        td {
            span {
                &.stock {
                    display: inline-block;
                    font-size: 11px;
                    padding: 2px 5px;
                    opacity: 1;

                    &.number {
                        padding: 0;
                        font-size: 14px;
                        font-weight: bold;
                        color: #4bcba8;
                    }

                    &.available {
                        background-color: #1e7b5d;
                    }

                    &.no-stock {
                        background-color: #cc0000;
                    }
                }
            }
        }
    }
}
</style>